import { useEffect, useState } from "react";
import { Box } from "@mantine/core";
import { useGlobalFetching } from "../hooks/useGlobalFetching";
import { useDelayedVisibility } from "../hooks/useDelayedVisibility";

export function GlobalBottomProgress() {
  const busy = useGlobalFetching();
  const visible = useDelayedVisibility(busy, 200, 300); // 200ms delay, 300ms minimum

  if (!visible) return null;

  return (
    <>
      <style>{`
        @keyframes bottombar-slide {
          0% { background-position-x: 200%; }
          100% { background-position-x: -200%; }
        }
      `}</style>
      <Box
        style={{
          position: "fixed",
          insetInlineStart: 0,
          insetBlockEnd: 0, // ⬅️ istället för top
          width: "100%",
          height: 15,
          zIndex: 10000,
          background:
            "linear-gradient(90deg, transparent, var(--mantine-color-blue-6), transparent)",
          backgroundSize: "200% 100%",
          animation: "bottombar-slide 1.2s linear infinite",
          boxShadow: "0 -1px 0 rgba(0,0,0,.05)", // ⬅️ skugga uppåt
        }}
      />
    </>
  );
}
